export default __webpack_public_path__ + "f2ca73ece0215ad4a27d2632495f14d8.png";